/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: () => ({
        swatchGroup: {
            flexDirection: 'column '
        },
        swatchLabel: {
            marginBottom: 2,
            marginTop: 2
        },
        swatch: {
            position: 'relative',
            backgroundColor: 'white',
            _focus: {
                outline: 'none',
                boxShadow: 'outline'
            }
        },
        swatchesWrapper: {
            flexWrap: 'wrap',
            gap: '8px'
        },
        swatchButton: {
            _disabled: {
                opacity: 1
            }
        }
    }),
    variants: {
        circle: (props) => ({
            swatch: {
                height: 12,
                width: 12,
                borderRadius: 'full',
                padding: 1,
                cursor: 'pointer',
                marginRight: 2,
                marginLeft: 0,
                marginBottom: 2,
                color: `${props.selected ? 'black' : 'gray.200'}`,
                border: `${props.selected ? '2px' : '2px'}`,
                _hover: {
                    borderColor: `${props.selected ? 'black' : 'gray.200'}`,
                    borderWidth: 1,
                    borderStyle: 'solid'
                },
                _active: {
                    background: 'transparent'
                },
                _before: {
                    content: '""',
                    display: `${props.disabled ? 'block' : 'none'}`,
                    position: 'absolute',
                    height: 12,
                    width: '1px',
                    transform: 'rotate(45deg)',
                    backgroundColor: 'black',
                    zIndex: 1
                }
            },
            swatchButton: {
                height: 8,
                borderColor: 'gray.200',
                width: 8,
                overflow: 'hidden',
                borderRadius: 'full',
                minWidth: 'auto',
                opacity: 1,
                _focus: {
                    outline: 'none'
                }
            }
        }),
        square: (props) => ({
            swatch: {
                marginRight: 2,
                // diagonal line for disabled options
                // theme variable like gray.200 won't work inside linear-gradient
                backgroundImage: `${
                    props.disabled
                        ? `${
                              props.selected
                                  ? 'linear-gradient(to top left, transparent calc(50% - 1px), black, transparent calc(50% + 1px) )'
                                  : 'linear-gradient(to top left, white calc(50% - 1px), #c9c9c9, white calc(50% + 1px) )'
                          } `
                        : ''
                }`,
                borderColor: `${props.selected ? 'black' : '#59595B'}`,
                borderStyle: 'solid',
                borderWidth: 2,
                paddingLeft: 2,
                paddingRight: 2,
                marginBottom: 2,
                borderRadius: '8px',
                minWidth: 12,
                minHeight: 12,
                fontSize: '20px !important',
                _focus: {outline: 'none'},
                _hover: {
                    textDecoration: 'none',
                    borderColor: 'gray.900'
                },
                _active: {
                    borderColor: 'gray.900'
                },
                backgroundColor: `${
                    props.selected ? (props.disabled ? 'gray.100' : 'black') : 'white'
                }`,
                color: `${props.selected && !props.disabled ? 'white' : 'gray.900'}`
            },
            swatchButton: {}
        })
    },
    parts: ['swatch', 'swatchButton']
}
